import { useQuery } from "@tanstack/react-query";

import { ListFieldMappingsResponse } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

export const FIELD_MAPPINGS_QUERY_KEY = ["fieldMappings"];

/** Every mapping the company has configured, which is at most one per kind of record. */
export function useFieldMappings(enabled = true) {
  const api = useIntegrationApi();

  return useQuery<ListFieldMappingsResponse>(
    FIELD_MAPPINGS_QUERY_KEY,
    () => api.listFieldMappings(),
    { enabled },
  );
}
